<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card shadow="never">
          <el-row :gutter="20">
            <el-col class="text-md-left" :span="10">
                <el-input
                    placeholder="ค้นหา"
                    v-model="searchText"
                    @input="onSearch()"
                    >
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
            </el-col>
            <el-col class="text-md-left" :span="5">
                <el-button type="primary" @click="onSearch()">เรียกข้อมูล</el-button>
            </el-col>
             <el-col class="text-md-right btn-box" :span="9">
                 <FilterDropdown
                    :dateSort="false"
                    :fixedstatus="true"
                    ref="dropdownParent"
                    :filterDropdownCase.sync="filterDropdownCase"
                    :isOpenFilterDropdown="isOpenFilterDropdown"
                    :handleChangeVisibility="handleChangeVisibility"
                >
                <template v-slot:closeFilter>
                    <el-button @click="cancelFilter" data-testid="btnCancel" style="width:100%">
                        Cancel
                    </el-button>
                </template>
                <template v-slot:searchFilter>
                    <el-button type="primary" style="width:100%" @click="onSearch">
                        Submit
                    </el-button>
                </template>
                 </FilterDropdown>
                <div class="btn-export-box">
                    <el-button type="primary" class="btn-export" @click="isDialogExportCustomer = true">Export</el-button>
                </div>
            </el-col>
        </el-row>
        <el-row style="margin-top:10px">
            <el-col class="text-md-left" :sm="24">
                <el-table
                    v-loading="loadingTable"
                    :data="userList"
                    stripe
                    :default-sort = "{prop: 'createdAt', order: 'descending'}"
                    :header-cell-style="{'background-color': 'black', 'color': 'white'}"
                    style="width: 100%"
                    ref="customerTable"
                    row-key="userId"
                    @selection-change="handleSelectionChange">
                    <el-table-column v-model="customerSelection" :reserve-selection="true" type="selection" align="center" width="55" />
                    <el-table-column fixed prop="userCode"  label="รหัสลูกค้า" width="120"></el-table-column>
                    <el-table-column  label="ชื่อลูกค้า" width="200">
                        <div class="text-md-left" slot-scope="scope">
                            {{scope.row.firstName}} {{scope.row.lastName}}
                        </div>
                    </el-table-column>
                    <el-table-column prop="email" label="อีเมล์" min-width="200"></el-table-column>
                    <el-table-column prop="isEmailVerify" label="ยืนยันอีเมล์" width="100">
                        <div slot-scope="scope">
                            <i :style="{'color' : scope.row.isEmailVerify ? '#67C23A' : '#F56C6C', 'font-size': '1.5rem'}" :class="{'el-icon-check' : scope.row.isEmailVerify, 'el-icon-close': !scope.row.isEmailVerify}"></i>
                        </div>
                    </el-table-column>
                    <el-table-column prop="createdAt" label="สร้างเมื่อ" width="102">
                        <template slot-scope="scope">
                            {{scope.row.createdAt | dayjs('format', 'YYYY-MM-DD HH:mm:ss')}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="phoneNumber" label="เบอร์โทรลูกค้า" width="150"></el-table-column>
                      <el-table-column prop="isVerify" label="ยืนยัน">
                        <div slot-scope="scope">
                            <i :style="{'color' : scope.row.isVerify ? '#67C23A' : '#F56C6C', 'font-size': '1.5rem'}" :class="{'el-icon-check' : scope.row.isVerify, 'el-icon-close': !scope.row.isVerify}"></i>
                        </div>
                    </el-table-column>
                     <el-table-column prop="Activate" label="Activate" width="100">
                        <div slot-scope="scope">
                            <i :style="{'color' : scope.row.isActivate ? '#67C23A' : '#F56C6C', 'font-size': '1.5rem'}" :class="{'el-icon-check' : scope.row.isActivate, 'el-icon-close': !scope.row.isActivate}"></i>
                        </div>
                    </el-table-column>
                    <el-table-column  label="New/Exist" width="100">
                        <div class="text-md-left" slot-scope="scope">
                            {{getCustomerStatusAccount(scope.row.userStatus)}}
                        </div>
                    </el-table-column>
                    <el-table-column label="สถานะสมัครประจำ" width="150">
                        <div class="text-md-left" slot-scope="scope">
                            {{getOnlineStatus(scope.row.approveStatus)}}
                        </div>
                    </el-table-column>

                    <el-table-column  label="สถานะแพ็คเกจ" width="150">
                        <div class="text-md-left" slot-scope="scope" >
                            {{getSubscriptionStatusLabel(scope.row.subscriptionStatus)}}
                        </div>
                    </el-table-column>

                    <el-table-column  label="สถานะการจ่ายเงิน"  width="150">
                        <div class="text-md-left" slot-scope="scope">
                            {{getSubscriptionPaymentStatusLabel(scope.row.subscriptionStatus)}}
                        </div>
                    </el-table-column>

                    <el-table-column  label="การยืนยันตัวตน"  width="150">
                        <div class="text-md-left" slot-scope="scope">
                            {{getApproveStatusLabel(scope.row.approveStatus, scope.row.isApprove) }}
                        </div>
                    </el-table-column>

                     <el-table-column label="สมัครเมื่อ" width="102">
                        <div class="text-md-left" slot-scope="scope">
                           {{scope.row.registedAt|dayjs('format', 'YYYY-MM-DD HH:mm:ss')}}
                        </div>
                    </el-table-column>
                     <el-table-column label="สมัครโดย" width="100">
                        <div class="text-md-left" slot-scope="scope">
                           {{registerCheck(scope.row.saleCode)}}
                        </div>
                    </el-table-column>
                    <el-table-column fixed="right" label="จัดการ" width="300">
                        <template slot-scope="scope">
                            <el-button size="small" icon="el-icon-edit" type="warning" plain @click="showUserDetail(scope.row)"></el-button>
                            <el-button size="small" icon="el-icon-document" type="info" plain @click="showShop(scope.row)"></el-button>
                            <el-button size="small" icon="el-icon-printer" type="info" plain @click="pdfMake(scope.row)" class="btn-pdf"></el-button>
                            <el-button size="small" icon="el-icon-document-checked" type="primary" plain @click="onApprove(scope.row)"></el-button>
                            <el-button size="small" icon="el-icon-document-delete" type="danger" plain @click="onApproveReject(scope.row)"></el-button>
                            <!-- <el-button size="small" icon="el-icon-edit-outline" type="danger" plain @click="onOnCustomerReject(scope.row)"></el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col style="margin-top:10px;">
                <el-pagination
                    @size-change="changeLimitPage"
                    @current-change="changeCurrentPage"
                    :current-page.sync="pagination.currentPage"
                    :page-sizes="pagination.pageSizes"
                    :page-size="10"
                    layout="prev, pager, next, sizes"
                    :total="pagination.allPage * pagination.limit">
                </el-pagination>
            </el-col>
        </el-row>
        </el-card>
      </el-col>
    </el-row>
            <modal-shop-detail :data.sync="shopDetailDialog"
            :geoHierarchyData="geoHierarchyData"
            :provinceArray="provinceArray"
            :zipcodeArray="zipcodeArray"
            @close="fetchListUser"
            />
    <online-operation-dialog :onlineOperationDetail.sync="onlineOperationDetail"/>
    <customer-base
        :detail.sync="customerDetail"
        :geoHierarchyData="geoHierarchyData"
        :provinceArray="provinceArray"
        :objUser="userDetail"
        @refreshUser="fetchListUser"
        @closeModalCustomer="closeDialog"
        customerType="approveCustomer"
    />
    <dialog-export-customer
        :isDialogExportCustomer="isDialogExportCustomer"
        :customerSelected="customerSelection"
        :customerFilter="filterDropdownCase"
        :searchTextForFilter="searchText"
        customerType="approvedCustomer"
        @onCloseDialog="isDialogExportCustomer = false"
        @onExportSuccess="$refs.customerTable.clearSelection()" />
  </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import OnlineOperationDialog from '@/components/OnlineOperation/OnlineOperationRejectDialog'
import FilterDropdown from '@/components/FilterDropdown/FilterDropdown'
import ModalShopDetail from '@/components/Shop/DialogShop'
import pdfMake from '@/mixins/pdfUserInfo.js'
import onlineOperationUtility from '@/mixins/onlineOperationUtility.js'
import CustomerBase from '@/components/Customer/CustomerBase'
import DialogExportCustomer from '@/components/helper/DialogExportCustomer.vue'

export default {
    components: {
        ModalShopDetail,
        OnlineOperationDialog,
        CustomerBase,
        FilterDropdown,
        DialogExportCustomer
    },
    mixins: [pdfMake, onlineOperationUtility],
    data () {
        return {
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            },
            searchText: '',
            isOpenFilterDropdown: false,
            filterDropdownCase: {
                package_code: null,
                subscription_type: null,
                account_status: null,
                expire_within: false
            },
            filterDropdownShowCase: {
                package_code: null,
                subscription_type: null,
                account_status: null,
                expire_within: false
            },
            loadingTable: false,
            userList: [],
            timeoutSearch: null,
            geoHierarchyData: {},
            provinceArray: [],
            dialogShow: false,
            userDetail: {},
            dialogCustomer: false,
            shopIds: [],
            dialogShopShow: false,
            shopInfoSel: {},
            customerDetail: {
                dialog: false,
                data: {},
                operationTag: [],
                is_customer_regis: false,
                pickupAddressShop: [],
                isSelectAddress: false,
                isCheckDelete: false,
                isCheckEditBooking: false
            },
            shopDetailDialog: {
                dialogVisible: false,
                shopDetail: {},
                is_customer_regis: false,
                btnSaveShow: false
            },
            sellerList: [],
            zipcodeArray: [],
            onlineOperationDetail: {
                dialog: false,
                approveStatus: '',
                userId: '',
                userCode: '',
                mainCourier: '',
                pickedUpInfo: [],
                pickedUpDate: '',
                pickedUpDays: [],
                data: [],
                bankAccountInfo: [],
                imgArr: []
            },
            baseSubscriptionData: {},
            isDialogExportCustomer: false,
            customerSelection: []
        }
    },
    created () {
        let zipcodeArr = []
        let geoJsonData = require('@/assets/geo.json')
        geoJsonData.forEach(e => {
            if (!(e['province'] in this.geoHierarchyData)) {
                this.geoHierarchyData[e['province']] = {}
            }
            if (!(e['amphoe'] in this.geoHierarchyData[e['province']])) {
                this.geoHierarchyData[e['province']][e['amphoe']] = {}
            }
            if (
                !(
                    e['district'] in
                    this.geoHierarchyData[e['province']][e['amphoe']]
                )
            ) {
                this.geoHierarchyData[e['province']][e['amphoe']][e['district']] = e['zipcode']
            }
        })
        for (let provice in this.geoHierarchyData) {
            this.provinceArray.push(provice)
        }
        zipcodeArr = [...new Set(zipcodeArr)]
        this.zipcodeArray = zipcodeArr.sort()
        this.fetchListUser()
    },
    methods: {
        cancelFilter () {
            this.isOpenFilterDropdown = false
            this.$nextTick(() => {
                this.$refs.dropdownParent.$refs.dropdown.hide()
            })
            this.filterDropdownCase = this.filterDropdownShowCase
        },
        closeFilter () {
            this.isOpenFilterDropdown = false
            this.$nextTick(() => {
                this.$refs.dropdownParent.$refs.dropdown.hide()
            })
        },
        handleChangeVisibility (value) {
            this.isOpenFilterDropdown = value
        },
        changeLimitPage (val) {
            this.pagination.limit = val
            this.fetchListUser()
        },
        changeCurrentPage (val) {
            this.pagination.offset = (this.pagination.currentPage * this.pagination.limit) - this.pagination.limit
            this.fetchListUser()
        },
        onSearch () {
            this.pagination.offset = 0
            this.pagination.currentPage = 1
            this.fetchListUser()
            if (JSON.stringify(this.filterDropdownCase) !== JSON.stringify(this.filterDropdownShowCase)) {
                this.filterDropdownShowCase = this.filterDropdownCase
            }
            this.closeFilter()
            this.$refs.customerTable.clearSelection()
        },
        async fetchListUser () {
            clearTimeout(this.timeoutSearch)
            this.timeoutSearch = setTimeout(async () => {
                this.loadingTable = true
                let param = {
                    search: this.searchText,
                    limit: this.pagination.limit,
                    offset: this.pagination.offset,
                    expire_within: this.filterDropdownCase.expire_within ? 7 : null,
                    account_status: this.filterDropdownCase.account_status,
                    subscription_type: this.filterDropdownCase.subscription_type,
                    package_code: this.filterDropdownCase.package_code
                    // is_approve: false,
                    // is_activate: true,
                    // is_finance_confirm: true
                }
                // let res = await fgApi.user.getUserListOpt(param)
                let res = await fgApi.user.searchConfirmedUser(param)
                if (res.success) {
                    if (this.searchText === param.search) {
                        this.userList = res.data
                        this.pagination.allPage = res.allPage
                    }
                }

                this.loadingTable = false
            }, 1000)
        },
        async showUserDetail (data) {
            this.customerDetail.dialog = !this.customerDetail.dialog
            await this.onGetSubscription(data.userId)
            this.customerDetail.data = { ...data, ...this.baseSubscriptionData }
            this.customerDetail.is_customer_regis = false
            this.customerDetail.operationTag = []
            let param = {
                user_id: data.userId
            }
            try {
                let getAllPickupAddress = await fgApi.user.getAllPickupAddressShop(param)
                if (getAllPickupAddress.success) {
                    this.customerDetail.pickupAddressShop = getAllPickupAddress.data
                }
                let operationTagRes = await fgApi.log.getOperationCancelTag(param)
                if (operationTagRes.success) {
                    for (let calcelOnline in operationTagRes.data) {
                        this.customerDetail.operationTag.push(this.getOperationTag(operationTagRes.data[calcelOnline]))
                    }
                } else {
                    alert(operationTagRes.message)
                }
            } catch (error) {
                this.$notify.error({
                    title: 'Error',
                    message: error
                })
            }
        },
        closeDialog () {
            this.customerDetail.dialog = !this.customerDetail.dialog
            this.customerDetail.data = { }
        },
        async showShop (data) {
            this.$loading()
            let param = {
                target_user_id: data.userId,
                search: '',
                limit: null,
                offset: null
            }
            try {
                let res = await fgApi.shop.searchListShop(param)
                if (res.data.length === 0) {
                    this.$notify.info({
                        title: 'Info',
                        message: 'No shop'
                    })
                    this.$loading().close()
                    return
                }
                if (res.success) {
                    this.$loading().close()
                    // this.dialogShopShow = !this.dialogShopShow
                    this.shopIds = []
                    res.data.forEach(e => this.shopIds.push({ shopId: String(e.shopId), shopName: e.name }))
                    let shopFrist = res.data[0]
                    Object.entries(shopFrist.financeConfig).forEach(e => {
                        shopFrist.financeConfig[e[0]]['zipcodeArr'] = []
                        Object.entries(shopFrist.financeConfig[e[0]].remoteZone).forEach(s => {
                            if (s[0] !== 'cost') {
                                shopFrist.financeConfig[e[0]].zipcodeArr.push(s[0])
                            }
                        })
                    })
                    if (shopFrist.bankName === 0) {
                        shopFrist.bankName = null
                    }
                    // this.shopInfoSel = shopFrist
                    this.shopDetailDialog.dialogVisible = !this.shopDetailDialog.dialogVisible
                    this.shopDetailDialog.shopDetail = JSON.parse(JSON.stringify(shopFrist))
                }
            } catch (error) {
                this.$notify.info({
                    title: 'Info',
                    message: error
                })
            }
        },
        async pdfMake (data) {
            let shopList = []
            this.$loading()
            let param = {
                target_user_id: data.userId,
                search: '',
                limit: null,
                offset: null
            }
            try {
                let res = await fgApi.shop.searchListShop(param)
                if (res.data.length === 0) {
                    shopList = []
                } else {
                    shopList = res.data
                }
                if (res.success) {
                    let param = {
                        target_user_id: data.userId
                    }
                    let resCourier = await fgApi.courier.getCourierByUserID(param)
                    if (resCourier.success) {
                        let courierList = []
                        resCourier.data.autoCourier.map((e) => {
                            resCourier.data.courierAccounts.filter(el => {
                                if (el.courierAccountId === e.courierAccountId) {
                                    courierList.push({ ...el, day: e.day })
                                }
                            })
                        })
                        await this.pdfgen(data, courierList, shopList)
                    }

                    this.$loading().close()
                }
            } catch (error) {
                this.$notify.info({
                    title: 'Info',
                    message: error
                })
            }

            this.$loading().close()
        },
        onApprove (data) {
            this.$confirm('Approve Confirm? ' + this.$store.get('user/objUser').email, 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(async () => {
                this.$loading()
                const param = {
                    user_id: data.userId,
                    approved_by: this.$store.get('user/objUser').email
                }
                try {
                    let res = await fgApi.seller.approveCustomer(param)
                    if (res.success) {
                        this.fetchListUser()
                        this.$notify({
                            title: 'Success',
                            message: 'Update Success',
                            type: 'success'
                        })
                    } else {
                        this.$notify.error({
                            title: 'Error',
                            message: res.message
                        })
                    }
                } catch (error) {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    })
                }
                this.$loading().close()
            }).catch(() => {
                // console.log('canceled')
            })
        },
        onApproveReject (data) {
            this.$confirm('ตรวจสอบและพบความไม่ถูกต้องของข้อมูลลูกค้า ต้องการตีกลับใช่หรือไม่ ?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(async () => {
                this.$loading()
                const param = {
                    user_id: data.userId,
                    is_finance_confirm: false
                }
                try {
                    let res = await fgApi.seller.financeConfirm(param)
                    if (res.success) {
                        this.fetchListUser()
                        this.$notify({
                            title: 'Success',
                            message: 'Update Success',
                            type: 'success'
                        })
                    } else {
                        this.$notify.error({
                            title: 'Error',
                            message: res.message
                        })
                    }
                } catch (error) {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    })
                }
                this.$loading().close()
            }).catch(() => {
                // console.log('canceled')
            })
        },
        async onOnCustomerReject (data) {
            this.$loading()
            this.onlineClear()
            this.onlineOperationDetail.userId = data.userId
            this.onlineOperationDetail.userCode = data.userCode
            this.onlineOperationDetail.approveStatus = data.approveStatus
            this.onlineOperationDetail.data[2].onlineData = data.firstName
            this.onlineOperationDetail.data[3].onlineData = data.lastName
            let shopParams = {
                target_user_id: data.userId,
                search: '',
                limit: null,
                offset: null
            }

            let courierParam = {
                target_user_id: data.userId
            }

            try {
                let resShop = await fgApi.shop.searchListShop(shopParams)

                let resCourier = await fgApi.courier.getCourierByUserID(courierParam)

                if (resShop.success && resCourier.success) {
                    for (const index in this.onlineOperationDetail.data) {
                        let key = this.onlineOperationDetail.data[index].key
                        if (resShop.data[0].hasOwnProperty(key)) {
                            this.onlineOperationDetail.data[index].onlineData = resShop.data[0][key]
                        }
                    }
                    for (const index in this.onlineOperationDetail.bankAccountInfo) {
                        let key = this.onlineOperationDetail.bankAccountInfo[index].key
                        if (resShop.data[0].hasOwnProperty(key)) {
                            this.onlineOperationDetail.bankAccountInfo[index].onlineData = resShop.data[0][key]
                        }
                    }
                    for (const index in this.onlineOperationDetail.pickedUpInfo) {
                        let key = this.onlineOperationDetail.pickedUpInfo[index].key
                        if (resShop.data[0].hasOwnProperty(key)) {
                            this.onlineOperationDetail.pickedUpInfo[index].onlineData = resShop.data[0][key]
                        }
                    }
                    this.onlineOperationDetail.pickedUpDate = resShop.data[0].startPickupAt
                    this.onlineOperationDetail.pickedUpDays = this.setDaysArr(resShop.data[0].pickedUpDay)
                    this.onlineOperationDetail.mainCourier = resCourier.data.courierAccounts[0].name

                    this.onlineOperationDetail.dialog = true
                } else {
                    this.$message({
                        message: resShop.message + resCourier.message,
                        type: 'error',
                        showClose: true
                    })
                }
            } catch (error) {
                this.$notify.error({
                    title: 'Error',
                    message: error
                })
            }
            this.$loading().close()
        },
        onlineClear () {
            this.onlineOperationDetail.data = [
                { id: 0, label: 'ประเภทบัญชี', paramLabel: 'bank_account_type', isValid: true, onlineData: '-', key: 'bankAccountType', span: 12 },
                { id: 1, label: 'ชื่อนิติบุคคล', paramLabel: 'legal_name', isValid: true, onlineData: '-', key: 'legalName', span: 12 },
                { id: 2, label: 'ชื่อ', paramLabel: 'first_name', isValid: true, onlineData: '-', key: 'firstName', span: 12 },
                { id: 3, label: 'นามสกุล', paramLabel: 'last_name', isValid: true, onlineData: '-', key: 'lastName', span: 12 },
                { id: 4, label: 'เลขประจำตัวผู้เสียภาษีนิติบุคคล', paramLabel: 'tax_id', isValid: true, onlineData: '-', key: 'taxId', span: 24 },
                { id: 5, label: 'ที่อยู่ตามใบกำกับภาษี', paramLabel: 'bank_account_address', isValid: true, onlineData: '-', key: 'bankAccountAddress', span: 24 },
                { id: 6, label: 'จังหวัด', paramLabel: 'bank_account_province', isValid: true, onlineData: '-', key: 'bankAccountProvince', span: 12 },
                { id: 7, label: 'อำเภอ', paramLabel: 'bank_account_district', isValid: true, onlineData: '-', key: 'bankAccountDistrict', span: 12 },
                { id: 8, label: 'ตำบล', paramLabel: 'bank_account_sub_district', isValid: true, onlineData: '-', key: 'bankAccountSubDistrict', span: 12 },
                { id: 9, label: 'รหัสไปรษณีย์', paramLabel: 'bank_account_zipcode', isValid: true, onlineData: '-', key: 'bankAccountZipcode', span: 12 }
            ]
            this.onlineOperationDetail.pickedUpInfo = [
                { id: 0, label: 'ที่อยู่เข้ารับสินค้า', onlineData: '-', key: 'pickedUpAddress', span: 24 },
                { id: 1, label: 'จังหวัด', onlineData: '-', key: 'pickedUpProvince', span: 12 },
                { id: 2, label: 'อำเภอ', onlineData: '-', key: 'pickedUpDistrict', span: 12 },
                { id: 3, label: 'ตำบล', onlineData: '-', key: 'pickedUpSubDistrict', span: 12 },
                { id: 4, label: 'รหัสไปรษณีย์', onlineData: '-', key: 'pickedUpZipcode', span: 12 }
            ]
            this.onlineOperationDetail.bankAccountInfo = [
                { id: 0, label: 'บัญชีธนาคาร', paramLabel: 'bank_name', isValid: true, onlineData: '-', key: 'bankName', span: 12 },
                { id: 1, label: 'หมายเลขบัญชีธนาคาร', paramLabel: 'bank_account_number', isValid: true, onlineData: '-', key: 'bankAccountNumber', span: 12 },
                { id: 2, label: 'ชื่อบัญชี', paramLabel: 'bank_account_name', isValid: true, onlineData: '-', key: 'bankAccountName', span: 24 }
            ]
            this.onlineOperationDetail.imgArr = [
                { id: 0, label: 'รูปบัตรประชาชน', imgPath: require('@/assets/no_image.png'), paramLabel: 'id_card_image', isValid: true },
                { id: 1, label: 'รูปหน้า Book Bank', imgPath: require('@/assets/no_image.png'), paramLabel: 'book_bank_image', isValid: true },
                { id: 2, label: 'หนังสือรับรองนิติบุคคล', imgPath: require('@/assets/no_image.png'), paramLabel: 'company_image', isValid: true }
            ]
        },
        registerCheck (val) {
            if (val === '') {
                return 'ลูกค้า'
            } else {
                return 'เซล'
            }
        },
        setDaysArr (arr) {
            let daysArr = []
            for (let dayIndex in arr) {
                daysArr.push(this.getTransportDay(arr[dayIndex]))
            }
            return daysArr
        },
        async onGetSubscription (userId) {
            try {
                const param = {
                    userId: userId
                }

                const res = await fgApi.subscription.getSubscription(param)

                const convertToPropsData = {
                    subscriptionData: { ...res.data }
                }

                this.baseSubscriptionData = convertToPropsData
            } catch (error) {
                const convertToPropsData = {
                    subscriptionData: null
                }

                this.baseSubscriptionData = convertToPropsData
            }
        },
        handleSelectionChange (val) {
            this.customerSelection = val
        }
    }
}
</script>
<style lang="scss" scoped>
.filter-dropdown-container{
    padding: 24px;
}
.mt{
    margin-top: 16px;
}
.col-middle{
    align-self: middle;
}
::v-deep .el-button {
    span .el-icon--right{
        display: none;
    }
}
::v-deep .el-radio{
    margin-top: 8px;
    width: 100%;
}
.btn-outline{
    color: #367E7F !important;
    background: #FFFFFF !important;
    border-color: #367E7F !important;
}
.btn-pdf{
    color: #409eff !important;
    background: #ecf5ff !important;
    border-color: #b3d8ff !important;

}
.btn-box {
    display: flex;
    justify-content: flex-end;
    .btn-export-box {
        margin-left: 16px;
        .btn-export {
            width: 90px;
            height: 40px;
        }
    }
}
</style>
